<nz-card [nzBordered]="false" style="margin: auto;">
  <nz-descriptions nzTitle="Vendor Information" [nzColumn]="3" nzBordered [nzExtra]="extraTemplate">
    <ng-template #extraTemplate>
      <button nz-button nzType="text" [nzSize]="'small'" (click)="editVendorDrawer(drawerVendorFooter)">
      <nz-icon nzType="edit" />
      </button>
      <button nz-button nzType="text" [nzSize]="'small'"
        nz-popconfirm style="margin-left:20px" nzDanger
        nzPopconfirmTitle="Are you sure delete this vendor?"
        nzPopconfirmPlacement="topRight"
        (nzOnConfirm)="deleteVendor()"
          class="custom-popconfirm"

            [nzPopconfirmOverlayClassName]="'custom-popconfirm-popover'"
            [nzPopconfirmTitle]="popconfirmTpl"

            >
        <nz-icon nzType="delete" />
      </button>
    </ng-template>
    <nz-descriptions-item nzTitle="Vendor Name">{{ data?.name }}</nz-descriptions-item>
    <!-- <nz-descriptions-item nzTitle="Contact Person">{{ data?.contact_person }}</nz-descriptions-item> -->
    <nz-descriptions-item nzTitle="Email">{{ data?.email }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Phone Number"> {{data?.country_code_details?.code}} {{ data?.phone_number }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Website">
      <a *ngIf="data?.website" [href]="data?.website" target="_blank">
        {{ data?.website }}
      </a>
    </nz-descriptions-item>
    <!-- <nz-descriptions-item nzTitle="Location">{{ data?.location }}</nz-descriptions-item> -->
    <nz-descriptions-item nzTitle="Address Line 1">{{ data?.address_1 }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Address Line 2">{{ data?.address_2 }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="City">{{ data?.city_details?.name }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="State">{{ data?.city_details?.state_name }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Country">{{ data?.city_details?.country_name }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Created By">{{ data?.created_by_name }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Modified By">{{ data?.modified_by_name }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Categories Serviced">
      @for (item of data?.categories_serviced; track item) {
        <nz-tag>
          {{ item.name }}
        </nz-tag>
      }
    </nz-descriptions-item>
    <!-- <nz-descriptions-item nzTitle="LinkedIn">{{ data?.linkedin }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Instagram">{{ data?.instagram }}</nz-descriptions-item> -->
    <nz-descriptions-item nzTitle="Business Name">{{ data?.registered_business_name }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Tax Identification">{{ data?.tax_type_name }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Tax Input">{{ data?.tax_input }}</nz-descriptions-item>


  </nz-descriptions>

  <nz-divider *ngIf="data?.poc_details?.length > 0"></nz-divider>




    <!-- <nz-list nzBordered nzHeader="POC Details" nzFooter="" *ngIf="data?.poc_details?.length > 0">

      @for (item of data?.poc_details; track item) {
        <nz-list-item>
          <div style="display: flex; align-items: flex-start; justify-content: space-between;width:100%">
            <div>
              <span>Name: </span> <span> {{ item?.contact_person }} </span> <br/>
              <span>Phone:</span> <span> {{item?.country_code_details?.code}} {{ item?.phone_number }} </span>
            </div>
            <div>
                <button nz-button nzType="text" nzSize="small" style="margin-left: 8px;"
                  nz-tooltip [nzTooltipTitle]="'Edit'"  nzTooltipPlacement="top"
                  ><nz-icon nzType="edit" nzTheme="outline" (click)="editPOC(item)" /></button>

                  <button nz-button nzType="text" nzDanger nzSize="small" style="margin-left: 8px;"
                   nz-popconfirm
                  nzPopconfirmTitle="Are you sure delete this task?"
                  nzPopconfirmPlacement="rightTop"
                  (nzOnConfirm)="deletePOC(item)"
                  ><nz-icon nzType="delete" nzTheme="outline" /></button>
            </div>
        </div>
        </nz-list-item>

      }
    </nz-list> -->

    <nz-list
      nzBordered
      nzHeader="POC Details"
      *ngIf="data?.poc_details?.length > 0"
    >
      <div class="poc-grid">
        @for (item of data?.poc_details; track item) {
          <div class="poc-card">
            <div class="poc-header">
              <h4 class="poc-name">
                {{ item?.contact_person }}
                <nz-tag *ngIf="item?.is_primary" color="green">Primary</nz-tag>
              </h4>
              <div class="poc-actions">
                <nz-tag *ngIf="!item?.is_primary"
                  class="action-tag setprimaryBtn"
                  (click)="setPrimaryPOCDetail(item)"
                >
                  Set Primary
                </nz-tag>

                <button
                  nz-button
                  nzType="text"
                  nzShape="circle"
                  nz-tooltip
                  [nzTooltipTitle]="'Edit'"
                  (click)="editPOC(item)"
                >
                  <nz-icon nzType="edit" nzTheme="outline"></nz-icon>
                </button>

                <!-- <button
                  nz-button
                  nzType="text"
                  nzShape="circle"
                  nzDanger
                  nz-tooltip
                  [nzTooltipTitle]="'Delete'"
                  nz-popconfirm
                  nzPopconfirmTitle="Are you sure to delete this POC?"
                  (nzOnConfirm)="deletePOC(item)"
                >
                  <nz-icon nzType="delete" nzTheme="outline"></nz-icon>
                </button> -->
                <button
                  nz-button
                  nzType="text"
                  nzShape="circle"
                  nzDanger
                  nz-tooltip
                  [nzTooltipTitle]="'Delete'"
                  nz-popconfirm
                  [nzPopconfirmTitle]="item.is_primary ? 'Primary POC cannot be deleted, change it first' : 'Are you sure to delete this POC?'"
                  [nzOkText]="item.is_primary ? 'OK' : 'Yes'"
                  [nzCancelText]="item.is_primary ? null : 'No'"
                  (nzOnConfirm)="handleDelete(item)"
                    class="custom-popconfirm"

            [nzPopconfirmOverlayClassName]="'custom-popconfirm-popover'"
            [nzPopconfirmTitle]="popconfirmTpl"
            nzPopconfirmPlacement="bottom"
                >
                <nz-icon nzType="delete" nzTheme="outline"></nz-icon>
                </button>
              </div>
            </div>

            <p><span class="label">📞 Phone:</span> {{ item?.country_code_details?.code }} {{ item?.phone_number }}</p>
            <p><span class="label">📧 Email:</span> <a href="mailto:{{ item?.email }}">{{ item?.email }}</a></p>
            <p><span class="label">💼 Designation:</span> {{ item?.designation }}</p>
            <p><span class="label">🔗 LinkedIn:</span>
              <!-- <a [href]="item?.linkedin" target="_blank" rel="noopener noreferrer">View Profile</a> -->
              <a [href]="item?.linkedin" target="_blank" rel="noopener noreferrer">{{item?.linkedin}}</a>

            </p>
          </div>
        }
      </div>
    </nz-list>


    <p *ngIf="data?.poc_details?.length == 0">No POC Details available.</p>

    <!-- <nz-divider></nz-divider> -->

    <!-- <nz-list nzBordered nzHeader="Categories Serviced" nzFooter="" *ngIf="data?.categories_serviced?.length">
      @for (item of data?.categories_serviced; track item) {
        <nz-list-item>
          {{ item }}
        </nz-list-item>
      }
    </nz-list>
    <p *ngIf="!data?.categories_serviced?.length">No categories listed.</p> -->

  <nz-divider>Notes</nz-divider>
  <nz-list nzBordered nzHeader="Notes" nzFooter=""  >

        <nz-list-item>
          {{ data?.notes || 'No notes available.' }}
        </nz-list-item>

  </nz-list>

  <nz-divider>Social</nz-divider>

  <nz-descriptions class="social-desc" nzTitle="Social" [nzColumn]="2" nzBordered>
    <nz-descriptions-item [nzSpan]="2" nzTitle="LinkedIn">
      <a *ngIf="data?.linkedin; else noLinkedIn"
        [href]="data?.linkedin"
        target="_blank"
        rel="noopener noreferrer"
        class="social-link">
        {{ data?.linkedin }}
      </a>
      <ng-template #noLinkedIn>NA</ng-template>
    </nz-descriptions-item>

    <nz-descriptions-item [nzSpan]="2" nzTitle="Instagram">
      <a *ngIf="data?.instagram; else noInstagram"
        [href]="data?.instagram"
        target="_blank"
        rel="noopener noreferrer"
        class="social-link">
        {{ data?.instagram }}
      </a>
      <ng-template #noInstagram>NA</ng-template>
    </nz-descriptions-item>
  </nz-descriptions>



  <div class="modal-footer" style="margin-top: 24px; text-align: right;">
    <button nz-button nzType="default" (click)="close()">Close</button>
  </div>
</nz-card>
<ng-template #drawerVendorFooter>
  <div style="text-align: right;">
    <button nz-button (click)="drawerRef?.close()">Cancel</button>
    <button nz-button nzType="primary" style="margin-left: 10px;"
      (click)="(drawerRef?.getContentComponent()?.onSubmit?.())">Submit</button>
  </div>
</ng-template>


<app-vendor-add-poc [data]="editPocData" [vendorID]="data?.id" [isVisible]="isVisibleAddPoc"
 [allPOCData]="data?.poc_details"  (closeDrawer)="closeAddPocEvent($event)" (closeDrawerData)="closeAddPoc($event)" ></app-vendor-add-poc>


 <ng-template #popconfirmTpl let-popconfirm="popconfirm">
    <div class="custom-popconfirm-header">
      <span class="custom-popconfirm-title">
          Confirm Deletion
      </span>
    </div>
    <div class="custom-popconfirm-icon-area">
        <span style="display: flex; justify-content: center; margin: 18px 0 8px 0;">
            <nz-icon nzType="warning-fill" nzTheme="fill" style="font-size: 32px; color: #ff6c6c;"></nz-icon>
        </span>
    </div>
    <div class="custom-popconfirm-message description">
        Are you sure you want to delete this item?<br />
        <span style="color:#888; font-size:14px;">This action cannot be undone.</span>
    </div>
</ng-template>
